module.exports = __webpack_public_path__ + "static/media/jobs.e4b205a8.pdf";